import { render } from "./IconMenuClient.vue?vue&type=template&id=db0f100a"
import script from "./IconMenuClient.vue?vue&type=script&lang=ts"
export * from "./IconMenuClient.vue?vue&type=script&lang=ts"
script.render = render

export default script